module.exports = __webpack_public_path__ + "static/media/totalPnts_500_750.b234e884.png";